function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// function allPossibleSearchCombos(passed_searchTerm, passed_synonym_keys){
//   let query_queue = [passed_searchTerm];
//   passed_synonym_keys.forEach(function(synonym_key){
//     let new_query = passed_searchTerm;
//     if(passed_searchTerm.includes(synonym_key)){
//       new_query = passed_searchTerm.replace(synonym_key,synonym_data[synonym_key]);
//     }
//     let passing_synonym_keys = passed_synonym_keys.filter(function(value, index, arr){ 
//       return value != synonym_key;
//     });
//     query_queue = query_queue.concat(allPossibleSearchCombos(new_query, passing_synonym_keys));
//   });
//   return [... new Set(query_queue)];
// }

function allPossibleSearchCombos(passed_searchTerm, passed_synonym_data){
  let query_queue = [passed_searchTerm];
  let passed_synonym_keys = Object.keys(passed_synonym_data);
  let filtered_synonym_keys = [];
  passed_synonym_keys.forEach(function(synonym_key){
    if(passed_searchTerm.includes(synonym_key)){
      filtered_synonym_keys.push(synonym_key);
    }
  });
  // debugger;
  filtered_synonym_keys.forEach(function(synonym_key){
    let new_query = passed_searchTerm;
    if(passed_searchTerm.includes(synonym_key)){
      new_query = passed_searchTerm.replace(synonym_key,passed_synonym_data[synonym_key][0]);
      let passing_synonym_data = { ...passed_synonym_data };
      let sub_passing_synonym_keys = passing_synonym_data[synonym_key].filter(function(value, index, arr){ 
        return index != 0;
      });
      passing_synonym_data[synonym_key] = sub_passing_synonym_keys;
      if(passing_synonym_data[synonym_key].length == 0){
        delete passing_synonym_data[synonym_key];
      }
      let passing_synonym_data1 = { ...passing_synonym_data };
      query_queue = query_queue.concat(allPossibleSearchCombos(new_query, passing_synonym_data));
      query_queue = query_queue.concat(allPossibleSearchCombos(passed_searchTerm, passing_synonym_data1));
    }
    else{
      let passing_synonym_data = { ...passed_synonym_data };
      delete passing_synonym_data[synonym_key];
      query_queue = query_queue.concat(allPossibleSearchCombos(new_query, passing_synonym_data));
      let passing_synonym_data1 = { ...passing_synonym_data };
      query_queue = query_queue.concat(allPossibleSearchCombos(passed_searchTerm, passing_synonym_data1));
    }
  });
  return [... new Set(query_queue)];
}

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.isOpen = false;

    this.setupEventListeners();
  }

  setupEventListeners() {
    const form = this.querySelector('form.search');
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('li');
    let activeElement = this.querySelector('li');

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    if (selectedProduct) selectedProduct.click();
  }

  getSearchResults(searchTerm) {
    var resultsMarkup = "";
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();
    let main_element = this;
    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[options][fields]')}=author,body,product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        return new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
        // debugger;
        // console.log("Here");
        // this.cachedResults[queryKey] = resultsMarkup;
        // this.renderSearchResults(resultsMarkup);
      })
      .then((resultsMarkup) => {
        let updated_searchTerm = searchTerm;
        let temp_synonym_data = { ...synonym_data };
        let query_queue = allPossibleSearchCombos(updated_searchTerm, temp_synonym_data);
        // synonym_keys.forEach(function(synonym_key, index){
        //   if(updated_searchTerm.includes(synonym_key)){
        //     query_queue.push(updated_searchTerm.replace(synonym_key,synonym_data[synonym_key]));
        //   }
        //   let updated_query_queue = [];
        //   for(var i = 0; i < query_queue.length; i++){
        //     if(query_queue.includes(synonym_key)){
        //       updated_query_queue.push(query_queue[i].replace(synonym_key,synonym_data[synonym_key]));
        //     }
        //   }
        //   query_queue = query_queue.concat(updated_query_queue);
        // });
        console.log(query_queue);
        for(var i = 0; i < query_queue.length; i++){
          let updated_searchTerm = query_queue[i];
          // debugger;
          // var originalResult = resultsMarkup.querySelector(".predictive-search__list-item");
          fetch(`/search/suggest?q=${encodeURIComponent(updated_searchTerm)}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[options][fields]')}=author,body,product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor&section_id=predictive-search`)
            .then((response) => {
              if (!response.ok) {
                var error = new Error(response.status);
                main_element.close();
                throw error;
              }

              return response.text();
            })
            .then((text) => {
              var new_resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
              // console.log(searchTerm);
              // console.log(resultsMarkup);
              // debugger;
              if(resultsMarkup.querySelector(".predictive-search__results-list .predictive-search__list-item")){
                // debugger;
                new_resultsMarkup.querySelectorAll(".predictive-search__list-item:not(.view-search-button)").forEach(function(inner_element){
                  if(!resultsMarkup.querySelector(".predictive-search__list-item:not(.view-search-button)[data-product-id='"+inner_element.getAttribute("data-product-id")+"']")){
                    resultsMarkup.querySelector(".predictive-search__results-list").insertBefore(inner_element,resultsMarkup.querySelector(".predictive-search__results-list .predictive-search__list-item.view-search-button"));
                  }
                });
              }
              else{
                resultsMarkup = new_resultsMarkup;
              }
              // resultsMarkup.querySelector(".predictive-search__results-list").append();
              // new_resultsMarkup.querySelector(".")
              // debugger;
              // console.log("Here1");
              // console.log(resultsMarkup);

              main_element.cachedResults[queryKey] = resultsMarkup.innerHTML;
              main_element.renderSearchResults(resultsMarkup.innerHTML);
            })
            .catch((error) => {
              main_element.close();
              throw error;
            });
        }
      })
      .catch((error) => {
        this.close();
        throw error;
      });
    // debugger;
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.getElementById('shopify-section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false
    this.predictiveSearchResults.removeAttribute('style');

    this.isOpen = false;
  }
}

customElements.define('predictive-search', PredictiveSearch);